import {DrawerFooter} from "@/widget/DrawerModal/DrawerModal";
import TextField from "@mui/material/TextField";
import {Controller, useForm} from "react-hook-form";
import {Autocomplete, FormLabel, Grid} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import React from "react"
import Box from "@mui/material/Box";
import {useAllDict} from "@/store/dict.c";
import {DictPO} from "@/model/system";
import {useDrawerModal, useGlobalActions} from "@/store/global.c";
import {SearchData} from "@/widget/SearchData/SearchData";
import {CurrencyYuanOutlined} from '@mui/icons-material';
import {DatePickers} from "@/theme/DatePickers";
import DatePicker from "react-datepicker";
import * as z from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {date2strTime, emptyValue, iso2Date} from "@/helper/method";
import {CustomerPO} from "@/model/customer";
import {SearchContractVO} from "@/service/contract.s";
import {RoleUserVO} from "@/service/user.s";
import {useRoleUsers} from "@/store/user.c";
import {useCreatePatent, useQueryPatent, useUpdatePatent} from "@/service/patent.s";
import {isNumber} from "lodash";
import dayjs from "dayjs";

const validationSchema = z.object({
        id: z.number().default(0),
        customerId: z.unknown(),
        customerName: z.string({message: "请选择客户名称"}).nonempty({message: "请选择客户名称"}),
        patentName: z.string({message: "请填写专利名称"}).nonempty({message: "请填写专利名称"}),
        applyNo: z.unknown({message: "请填写申请号/专利号"}),
        writer: z.unknown(),
        writerId: z.number({message: "请选择撰稿人"}),
        // price: z.number({message: '请填写单价'}).max(1000000, "单价不能大于百万").nullable(),
        price: z.unknown(),
        writeStatus: z.string({message: "请选择撰写状态"}).nonempty({message: "请选择撰写状态"}),
        writeStatusId: z.unknown(),
        category: z.string({message: "请选择申请类型"}).nonempty({message: "请选择申请类型"}),
        categoryId: z.unknown(),
        kind: z.string({message: "请选择服务类型"}).nonempty({message: '请选择服务类型'}),
        kindId: z.unknown(),
        retardId: z.unknown(),
        initialReviewDate: z.unknown().default(null),
        insideDeadline: z.unknown().default(null),
        boundaryDate: z.unknown().default(null),
        bulletinDate: z.unknown().default(null),
        actualReviewDate: z.unknown().default(null),
        assigner:
            z.unknown(),
        assignerId:
            z.number({message: "请选择分配人"}),
        tempAssigner:
            z.object({username: z.string().default(''), id: z.number()}).optional(),
        retard: z.string({message: '请选择费减比例'}),
        applyDate: z.unknown({message: "请选择申请时间"}),
        explain: z.unknown(),
        contractId: z.number().default(0),
        contractName: z.unknown(),
        sellerId:
            z.number({message: "请选择业务人员"}),
        handler:
            z.string({message: "请选择处理人"}).nonempty({message: "请选择处理人"}),
        handlerId:
            z.unknown(),
        tempHandler:
            z.object({username: z.string().default(''), id: z.number()}).optional(),
        seller:
            z.unknown(),
        tempWriter:
            z.object({username: z.string().default(''), id: z.number()}).optional(),
        tempSeller:
            z.object({username: z.string().default(''), id: z.number()}).optional(),
        patentStatus:
            z.unknown({message: "请选择案件状态"}),
        patentStatusId:
            z.unknown(),
        bulletinNo:
            z.unknown(),
    })
;

export type WritePatentForm = z.infer<typeof validationSchema>

const defaultValues = emptyValue(validationSchema)

export const WritePatent = () => {
    const allDict = useAllDict()
    const seller = useRoleUsers(["marketing", "manager"])
    const patenter = useRoleUsers(["patenter", "processer"])
    const handler = useRoleUsers(["processer"])
    const assigner = useRoleUsers(["processer"])
    const {patentType, patentKind, isRetard, patentStatus, writeStatus} = allDict
    const {setToast} = useGlobalActions()
    const {write, id: drawerId} = useDrawerModal()
    const {mutateAsync: createPatentMutate, isPending: createPatentPending} = useCreatePatent()
    const {mutateAsync: updatePatentMutate, isPending: updatePatentPending} = useUpdatePatent()
    const {data: patentData} = useQueryPatent({id: drawerId!}, isNumber(drawerId))
    const patent = patentData?.data
    const {onSearch} = useDrawerModal()
    const {setDrawerModal} = useGlobalActions()

    const initValues = () => {
        if (write == 'edit') {
            return {
                ...patent, initialReviewDate: iso2Date(patent?.initialReviewDate),
                boundaryDate: iso2Date(patent?.boundaryDate), actualReviewDate: iso2Date(patent?.actualReviewDate),
                applyDate: iso2Date(patent?.applyDate), bulletinDate: iso2Date(patent?.bulletinDate),
                tempWriter: {username: patent?.writer, id: patent?.writerId}, tempSeller: {username: patent?.seller, id: patent?.sellerId},
                tempAssigner: {username: patent?.assigner, id: patent?.assignerId}, contractName: patent?.contract?.contractName,
                insideDeadline: iso2Date(patent?.insideDeadline), tempHandler: {username: patent?.handler, id: patent?.handlerId}
            };
        }
        return {id: 0}
    }

    const {
        register,
        control,
        setValue,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<WritePatentForm>({
        values: initValues() as WritePatentForm,
        resolver: zodResolver(validationSchema),
        defaultValues,
    });
    const onSubmit = async (values: WritePatentForm) => {
        const result = write == 'add' ? await createPatentMutate({...values, applyDate: date2strTime(values.applyDate)}) :
            await updatePatentMutate({...values, applyDate: date2strTime(values.applyDate), id: drawerId!})
        if (result.code == 0) {
            onSearch && onSearch()
            setDrawerModal({open: false})
            setToast({open: true, message: result.msg, severity: "success", variant: 'standard'})
        } else {
            setToast({open: true, message: result.msg, severity: "error", variant: 'standard'})
        }
    }
    console.log(errors, 'kkkkkkkkk')
    return (
        <Box component={'form'} noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
                <Grid size={6}>
                    <FormControl fullWidth={true} autoFocus={true} required={true}>
                        <FormLabel>内部编号</FormLabel>
                        <TextField
                            {...register("id")}
                            placeholder="内部编号"
                            slotProps={{input: {readOnly: true}}}
                            variant="outlined"
                        />
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} autoFocus={true} required={true}>
                        <FormLabel>专利名称</FormLabel>
                        <TextField
                            {...register("patentName")}
                            error={!!errors?.patentName}
                            helperText={errors?.patentName?.message}
                            slotProps={{
                                input: {
                                    inputProps: {maxLength: 60},
                                },
                            }}
                            placeholder="填写专利名称"
                            variant="outlined"
                        />
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>服务类型</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={patentKind}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("kindId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.kind}
                                           helperText={errors?.kind?.message}
                                           variant="outlined"
                                           placeholder={"选择服务类型"} {...params} />
                            )}
                        />} name={"kind"}/>
                    </FormControl>
                </Grid>

                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>申请类型</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={patentType}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("categoryId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.category}
                                           helperText={errors?.category?.message}
                                           variant="outlined"
                                           placeholder={"选择申请类型"} {...params} />
                            )}
                        />} name={"category"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} autoFocus={true}>
                        <FormLabel>专利号/申请号</FormLabel>
                        <TextField
                            {...register('applyNo')}
                            // error={!!errors?.applyNo}
                            // helperText={errors?.applyNo?.message}
                            slotProps={{
                                input: {
                                    inputProps: {maxLength: 60},
                                },
                            }}
                            placeholder="填写申请号/专利号"
                            variant="outlined"
                        />
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} autoFocus={true}>
                        <FormLabel>申请时间</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <DatePickers>
                                <DatePicker
                                    showYearDropdown={true}
                                    showMonthDropdown={true}
                                    dateFormat="yyyy/MM/dd"
                                    selected={value as any}
                                    onChange={date => {
                                        onChange(date)
                                    }}
                                    locale='zhCN'
                                    placeholderText={"选择申请时间"}
                                    customInput={<TextField
                                        error={!!errors?.applyDate}
                                        helperText={errors?.applyDate?.message}
                                        sx={{
                                            width: "100%",
                                            "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                        }}
                                    />}
                                />
                            </DatePickers>
                        }} name={'applyDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>案件状态</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={patentStatus}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("patentStatusId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.patentStatus}
                                           helperText={errors?.patentStatus?.message}
                                           variant="outlined"
                                           placeholder={"选择案件状态"} {...params} />
                            )}
                        />} name={"patentStatus"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>费减比例</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={isRetard || []}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("retardId", option?.value)
                                onChange(option?.label)
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.retard}
                                           helperText={errors?.retard?.message}
                                           variant="outlined"
                                           placeholder={"选择费减比例"} {...params} />
                            )}
                        />} name={"retard"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>公告日</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择公告日"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'bulletinDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>公告号</FormLabel>
                        <TextField
                            {...register('bulletinNo')}
                            slotProps={{
                                input: {
                                    inputProps: {maxLength: 60},
                                },
                            }}
                            placeholder="填写公告号"
                            variant="outlined"
                        />
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>初步审查日</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择初步审查日"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'initialReviewDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>实质审查日</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择实质审查日"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'actualReviewDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>届满日</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择届满日"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'boundaryDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>处理人</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={handler}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("handlerId", option!.id)
                                    setValue("handler", option!.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.handler}
                                               helperText={errors?.handler?.message}
                                               variant="outlined"
                                               placeholder={"选择处理人"} {...params} />
                                )}
                            />
                        }} name={"tempHandler"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <SearchData<WritePatentForm, CustomerPO> control={control} attr={"customerName"} attrId={"customerId"} errMsg={errors.customerName?.message} setValue={setValue}
                                                             label={"关联客户"}/>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>业务人员</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={seller}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("sellerId", option!.id)
                                    setValue("seller", option?.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.sellerId}
                                               helperText={errors?.sellerId?.message}
                                               variant="outlined"
                                               placeholder={"选择业务人员"} {...params} />
                                )}
                            />
                        }} name={"tempSeller"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <SearchData<WritePatentForm, SearchContractVO> control={control} tag={2} attr={"contractName"} autoLoad={true} attrId={"contractId"} setValue={setValue}
                                                                   label={"关联合同"}/>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>单价</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <TextField
                            type={'number'}
                            value={value}
                            onChange={event => onChange(event.target.value)}
                            slotProps={{
                                input: {
                                    inputProps: {
                                        min: 0,
                                        max: 1000000,
                                        maxLength: 8, inputMode: 'numeric', pattern: '[0-9]*'
                                    },
                                    endAdornment: <CurrencyYuanOutlined color="disabled"/>,
                                },
                            }}
                            placeholder="填写单价"
                            variant="outlined"
                        />} name={'price'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>撰稿人</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={patenter}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("writerId", option!.id)
                                    setValue("writer", option?.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.writerId}
                                               helperText={errors?.writerId?.message}
                                               variant="outlined"
                                               placeholder={"选择撰稿人"} {...params} />
                                )}
                            />
                        }} name={"tempWriter"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>撰写状态</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={writeStatus}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("writeStatusId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.writeStatus}
                                           helperText={errors?.writeStatus?.message}
                                           variant="outlined"
                                           placeholder={"选择撰写状态"} {...params} />
                            )}
                        />} name={"writeStatus"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>分配人</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={assigner}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("assignerId", option!.id)
                                    setValue("assigner", option?.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.assignerId}
                                               helperText={errors?.assignerId?.message}
                                               variant="outlined"
                                               placeholder={"选择分配人"} {...params} />
                                )}
                            />
                        }} name={"tempAssigner"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>内部期限</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择内部期限"}
                                customInput={<TextField
                                    error={!!errors?.insideDeadline}
                                    helperText={errors?.insideDeadline?.message}
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'insideDeadline'}/>
                    </FormControl>
                </Grid>

                <Grid size={12}>
                    <FormControl fullWidth={true}>
                        <FormLabel>备注</FormLabel>
                        <TextField
                            multiline
                            rows={3}
                            {...register("explain")}
                            slotProps={{
                                input: {
                                    sx: {height: 'auto', minHeight: 80},
                                    inputProps: {
                                        maxLength: 250,
                                    },
                                },
                            }}
                            placeholder="输入备注"
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <DrawerFooter loading={createPatentPending || updatePatentPending} onReset={() => reset(defaultValues)}/>
        </Box>
    );
};
